const tg = window.Telegram.WebApp;

export function useTelegram() {

    const onClose = () => {
        tg.close();
    }

    const onToggleButton = () => {
        switch (tg.MainButton.isVisible) {
            case true:
                tg.MainButton.hide();
                break;

            case false:
                tg.MainButton.show();
                break;
        }
    }

    return {
        onClose,
        onToggleButton,
        tg,
        initData: tg.initData
    }

}